const scopeDict = {
  inicio: "Inicio",
  "admin-menu": "Menu de Administracion",
  "admin-users": "Administracion: Usuarios",
  "recepcion-menu": "Menu de Recepcion",
  "recepcion-ingreso": "Recepcion: Ingreso de Guias de recepcion de productos",
  "recepcion-listado": "Listado de guías de recepcion de productos",
  "recepcion-lotes": "Listado de lotes de recepcion",
  "recepcion-dashboard": "Dashboard: Estadistica de recepcion",
  "recepcion-editar": "Editar: modificar las guias de recepcion de productos",
  "procesos-menu": "Menu de Procesos",
  "procesos-ingreso": "Procesos: Ingreso de procesos",
  "procesos-ingreso-transformacion": "Ingreso de pallet a procesos",
  "procesos-ingreso-transformacion-editar": "Editar procesos",
  "procesos-ingreso-embalaje": "Ingreso de embalaje en procesos",
  "procesos-ingreso-palletizaje": "Ingreso de n° de pallet en procesos",
  "procesos-ingreso-embalaje-editar": "Editar embalaje en procesos",
  "process-listado": "Listado de procesos",
  "procesos-registros": "Registros de procesos",
  "process-dashboard": "Estadistica de procesos",
  "camara-menu": "Menu de camaras",
  "camara-stock-producto": "Listado de productos en stock",
  "camara-stock": "Seleccion de productos",
  "camara-listado-repaletizajes": "Listado de realetizajes",
  "camara-stockonl": "Listado de stock de todos los pruductos",
  "camara-camaras": " Cantidad de pallet por camara",
  "camara-stock-castana": "Listado de stock de producto terminado de castañas",
  "camara-mapeo": "Mapeo: Posiciones de los pallet en las camaras",
  "camara-stock-dashboard": "Estadistica de stock de fruta",
  "posiciones-menu": "Menu de posiciones",
  "posiciones-listado": "Listado de posiciones de pallet",
  "posiciones-historico": "Listado de pisiciones historico en camaras",
  "materiales-menu": "Menu de materiales",
  "materiales-cuenta-corriente": "Stock de materiales por productor",
  "materiales-ingreso": "Ingreso de guias de recepcion de materiales",
  "materiales-movimiento": "Detalle de movimiento de materiales",
  "materiales-editar-movimiento": " Modificar movimiento de materiales",
  "materiales-despacho": "Ingreso de guia de despacho de materiales",
  "materiales-editar-ingreso": "Editar ingresos de materiales",
  "materiales-editar-despacho": "Editar materiales en guias de despacho",
  "materiales-listado": "listado de guias de materiales",
  "materiales-stock": "Deprecado",
  "materiales-editar": " Modificar materiales",
  "despacho-menu": "Menu de despachos",
  "despacho-traslado": "Ingreso de guia de traslado de despacho",
  "despacho-traslado-interplanta": "Ingreso de traslados interplanta",
  "despacho-ingreso": "Ingreso de guias de despacho",
  "despacho-listado": "listado de despachos",
  "despacho-editar": "Editar las guias de despacho",
  "exportaciones-menu": "Menu de exportaciones",
  "exportaciones-instructivo": "Ingreso de formulario de instructivo de embarque",
  "exportaciones-listado-embarques": "Listado de embarques",
  "exportaciones-instructivo-editar": " Editar instructivo de embarque",
  "exportaciones-inspeccion": "Ingreso fromulario de Inspeccion",
  "exportaciones-listado-inspeccion": "lista de Inspecciones de embarque",
  "exportaciones-aprobar-inspeccion": "Aprobacion de inspecciones",
  "exportaciones-packing-list": "Creacion de packing list de embarque",
  "exportaciones-despacho-guia-exportacion": "Creacion de guia de despacho de exportacion",
  "exportaciones-listado-guias": "Listado deguias de despacho de exportacion",
  "exportaciones-editar-guia-exportacion": "Modificar guias de exportacion",
  "descargar-datos": "Descarga de datops CSV",
  "proforma-menu": "Menu de Proforma",
  "proforma-ingreso": "Creacion de proforma",
  "proforma-listado": "Listado de proformas creadas",
  "proforma-listado-alfaberries": "Listado de proformas creadas de Alfaberries",
  "calidad-menu": "Menu de Calidad",
  "calidad-listado-recepcion": "Listado de Inspecciones de recepcion",
  "calidad-listado-proceso": "Listado de Inspecciones de proceso",
  "calidad-asignar-clasificacion-por-pallet": "Asignar clasificacion a los pallet",
  "calidad-datos": "Descarga datos CSV",
  "calidad-detailed-lot-inspection": "Inspeccion de calidads detallada de lotes",
  "calidad-detailed-evaluations-lot": "Evaluaciones detalladas de lotes",
  "calidad-detailed-evaluations-lot-process": "Evaluaciones detalladas de lotes de procesos",
  historico: "Datos historicos de procesos, recepcion y pallet",
  "historico-inicio": "Inico de busqueda de Datos Historicos",
  "historico-buscar": "Buscar Historico de recepcion, procesos, pallet",
  trazabilidad: "Inicio modulo de trazabilidad",
  "trazabilidad-buscar": "Busqueda de pallet por temporada",
  "trazabilidad-detalle": "Informqación de detalles del pallet o lote buscado",
  "trazabilidad-pallet-repaletizado": "Detalle de trazabilidad de pallet repaletizado",
  "trazabilidad-detalle-guia-recepcion": "Detalle de trazabilidad de guia de recepcion",
  "trazabilidad-detalle-pallet": "Detalle de trazabilidad de pallet",
  "trazabilidad-detalle-proceso": "Detalle de trazabilidad de proceso",
  "trazabilidad-detalle-repaletizaje": "Detalle de trazabilidad de repalletizaje",
  "trazabilidad-detalle-lote": "Detalle de trazabilidad de lote",
  "trazabilidad-detalle-guia-despacho": "Detalle trazabilidad de guia de despacho",
  "trazabilidad-detalle-embarque": "Detalle trazabilidad de embarques",
  "trazabilidad-detalle-guia-exportacion": "Detalle trazabilidad de guia de exportacion",
  "oc-menu": "Menu Orden de Compra",
  "oc-ingreso": "Ingreso de Orden de Compra",
  "oc-listado": "Listado de Orden de Compra",
  "open-process": "Abrir proceso",
  "send-process-report": "Envio informe de proceso",
  "edit-process-start-time": "Editar hora de inico del proceso",
  "edit-process-end-time": "Editar hora de termino de proceso"
};
export default scopeDict;
